import React, { useState, useEffect } from 'react';

const InstallPWA = () => {
  // eslint-disable-next-line no-unused-vars
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [showIOSGuide, setShowIOSGuide] = useState(false);

  useEffect(() => {
    const ios = /iphone|ipad|ipod/.test(
      window.navigator.userAgent.toLowerCase()
    );
    setIsIOS(ios);
    
    console.log('PWA: Initializing installation handler');

    const handler = (e) => {
      console.log('PWA: beforeinstallprompt event triggered');
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };

    if (window.matchMedia('(display-mode: standalone)').matches) {
      console.log('PWA: Already installed in standalone mode');
    }

    const appInstalledHandler = () => {
      console.log('PWA: App was successfully installed');
      setSupportsPWA(false);
    };

    window.addEventListener('beforeinstallprompt', handler);
    window.addEventListener('appinstalled', appInstalledHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('appinstalled', appInstalledHandler);
    };
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handleChange = (e) => {
      if (e.matches) {
        console.log('PWA: App is running in standalone mode');
        setSupportsPWA(false);
      }
    };

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  // eslint-disable-next-line no-unused-vars
  const installPWA = async () => {
    console.log('PWA: Attempting to install');
    if (promptInstall) {
      promptInstall.prompt();
      const { outcome } = await promptInstall.userChoice;
      console.log('PWA: Installation outcome:', outcome);
      if (outcome === 'accepted') {
        console.log('PWA: Installation successful');
        setSupportsPWA(false);
      }
      setPromptInstall(null);
    } else {
      console.log('PWA: No install prompt available');
    }
  };

  const styles = {
    overlay: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '20px 24px',
      borderRadius: '12px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
      width: '300px',
      zIndex: 999,
      textAlign: 'center'
    },
    closeButton: {
      position: 'absolute',
      top: '5px',
      right: '10px',
      background: 'none',
      border: 'none',
      color: 'white',
      fontSize: '20px',
      cursor: 'pointer'
    },
    instructions: {
      fontSize: '16px',
      lineHeight: '1.4',
      marginTop: '10px'
    }
  };

  if (!isIOS) return null;

  return (
    <>
      {isIOS && showIOSGuide && (
        <div style={styles.overlay}>
          <button
            style={styles.closeButton}
            onClick={() => setShowIOSGuide(false)}
          >
            ×
          </button>
          <div style={styles.instructions}>
            1. Tap the Share button 📲<br />
            2. Choose "Add to Home Screen" ✚<br />
            3. Tap "Add" to install
          </div>
        </div>
      )}
    </>
  );
};

export default InstallPWA;
